import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/whitepaper-form.tsx");
